const API_LINK = 'https://appointments.yjcandwellness.com/api/';

export default API_LINK;
